import React from "react"
import {makeAutoObservable} from "mobx"
import experimentState, {ApplicationState} from "./experimentState";
import themeState from "./themeState";
import {create} from "random-seed";


function mouseSpeedFn(a, b) {
    // return [x * this.mouse_speed * experimentState.challengeState.compress_x, y * this.mouse_speed * experimentState.challengeState.compress_y]
    // console.log("doing thingy",this.mouse_transform_func,);
    let delta_x = a - this.mouse_enter_x;
    let delta_y = b - this.mouse_enter_y;


    // Check for unusually large deltas that might be caused by popups or other interruptions. Max 20% of the screen
    const MAX_DELTA = 0.2;
    // let chatpanel_x = (window.innerWidth);
    // let chatpanel_y = (window.innerHeight);
    console.log("chatpanel", window.innerWidth, window.innerHeight)
    if ((experimentState.fake_mouse_visible === true) && (Math.abs(delta_x) > (MAX_DELTA * window.innerWidth) || Math.abs(delta_y) > (MAX_DELTA * window.innerHeight))) {
        // Trigger recalibration if a large jump is detected
        if (experimentState.application_state === ApplicationState.APP_CHAT) {
            experimentState.setFakeMouseVisibility(false);
            experimentState.setApplicationState(ApplicationState.APP_MOUSE_CALIBRATION);
        }
    }

    let out = mouseState.mouseSpeedFuncs[this.mouse_transform_func % mouseState.mouseSpeedFuncs.length](this.mouse_enter_x, this.mouse_enter_y, delta_x, delta_y, this.mouse_origin_x, this.mouse_origin_y, this);
    this.mouse_enter_x = a;
    this.mouse_enter_y = b;
    let fake_x = out[0] + this.mouse_origin_x
    let fake_y = out[1] + this.mouse_origin_y
    this.mouse_origin_x = fake_x;
    this.mouse_origin_y = fake_y;
    return [fake_x, fake_y]
}

function randomize_lanes(rand) {
    let lanes = [];
    let lane_types = ['shift', 'speed']
    for (let i = 0; i < 12; i += 1) {
        let type = lane_types[Math.floor((lane_types.length * rand.random()))]
        lanes.push({
            type: type,
            shift: rand.floatBetween(0.2, 0.5) * (rand.random() > 0.5 ? -1 : 1),
            speed: rand.floatBetween(0.2, 0.5) * (rand.random() > 0.5 ? -1 : 1),
            width: rand.floatBetween(100, 200),
            x: rand.floatBetween(100 * i, 100 * (1 + i))
        })
        // lanex += lanes[lanes.length-1].width

    }
    return lanes;
}


function randomize_challenge(rand, returnLanes, returnMouse) {
    if (!returnLanes && !returnMouse) {
        return [[], 1.3, [// {type: "shift", shift: 80, width: 300, x: 300},
        ]]
    }
    if (returnMouse) {

        let chatpanel_x = (document.getElementById('chat_panel_text_area').getBoundingClientRect().left + document.getElementById('chat_panel_text_area').getBoundingClientRect().right) / 2;
        let real_x = mouseState.mouse_transforms[mouseState.mouse_transforms.length - 1].mouse_enter_x;
        let real_y = mouseState.mouse_transforms[mouseState.mouse_transforms.length - 1].mouse_enter_y;
        let fake_x = mouseState.mouse_x;
        let fake_y = mouseState.mouse_y;

        let shift = (fake_y - real_y) / (real_x - chatpanel_x);
        return [[], 1, [{
            type: "shift", shift: shift, width: fake_x - chatpanel_x, x: chatpanel_x,
        }, {
            type: "speed",
            speed: (fake_x - real_x) / (real_x - chatpanel_x),
            width: fake_x - chatpanel_x,
            x: chatpanel_x
        }
            // {type: "shift", shift: 80, width: 300, x: 300},
        ]]

    }

    let out = []
    let lanes = randomize_lanes(rand)
    let mouse_speed = 1.3
    return [out, mouse_speed, lanes]
}

function initTransform() {
    return {
        mouse_enter_x: window.innerWidth / 2,
        mouse_enter_y: window.innerHeight / 2,
        mouse_origin_x: window.innerWidth / 2,
        mouse_origin_y: window.innerHeight / 2,
        mouse_visible: false,
        mouse_speed: 1.3,
        mouseSpeedFn: mouseSpeedFn,
        mouse_transform_func: 0,
        mouse_speed_sin_intensity: 100,
        theta: 5 * (2 * Math.PI / 360),
        attractors: randomize_challenge(0, false, false)[0],
        lanes: randomize_challenge(0, false, false)[2],
        correction_strength: 0.1
    }
}

class MouseState {


    mouse_transforms = [initTransform()];
    mouseSpeedFuncs = [

        (x0, y0, x, y, fx0, fy0, that) => {
            // The input x,y represents where the fake mouse WOULD be if no transform was applied
            // (since it's the same delta from fake origin as the real mouse delta from real origin)
            // console.log(x0,y0,x, y, that)
            let delta_x = x * that.mouse_speed;
            let delta_y = y * that.mouse_speed;


            // Calculate where the fake mouse currently is
            const current_fake_x = fx0

            // Find location of the chats
            let ele = document.getElementById('chats')
            if (ele === null) {
                return [delta_x, delta_y]
            }
            let chats_x = ele.getBoundingClientRect().left
            let chats_y = ele.getBoundingClientRect().top

            for (let lane of that.lanes) {
                let right_lane_x = Math.max(Math.min(current_fake_x + delta_x, lane.x + chats_x + lane.width), lane.x + chats_x)
                let left_lane_x = Math.max(Math.min(current_fake_x, lane.x + chats_x + lane.width), lane.x + chats_x)
                if (current_fake_x + delta_x >= (lane.x + chats_x) && current_fake_x + delta_x < (lane.x + chats_x) + lane.width) {
                    if (lane.type === "shift") {
                        delta_y += lane.shift * (right_lane_x - left_lane_x)
                    } else if (lane.type === "speed") {
                        // console.log((right_lane_x - left_lane_x), lane.speed, lane.speed * (right_lane_x - left_lane_x))
                        delta_x += lane.speed * (right_lane_x - left_lane_x)
                    }
                }
            }

            return [delta_x, delta_y];
        }


    ];


    constructor() {
        makeAutoObservable(this);
    }

    setMouse(x, y) {
        // Calculate the position that the mouse should be at
        // X and Y are the real position of the mouse.


        let transform = this.mouse_transforms[this.mouse_transforms.length - 1]
        // console.log(transform)
        let mouseDelta = transform.mouseSpeedFn(x, y);
        // console.log(x,y,mouseDelta)
        this.real_x = x
        this.real_y = y
        this.mouse_x = mouseDelta[0];
        this.mouse_y = mouseDelta[1];
    }

    setMouseForce(x,y) {
        this.real_x = x
        this.real_y = y
        this.mouse_x = x;
        this.mouse_y = y;
    }

    // setMouseEnter(x, y) {
    //     this.mouse_transforms[this.mouse_transforms.length - 1].mouse_enter_x = x;
    //     this.mouse_transforms[this.mouse_transforms.length - 1].mouse_enter_y = y;
    //     this.mouse_enter_x = x;
    //     this.mouse_enter_y = y;
    // }

    // setMouseVisible(visibility) {
    //     // console.log("Setting mouse visibility to",visibility);
    //     this.mouse_visible = visibility;
    // }

    addTransform(out) {
        // console.log('Rolling transform')
        let transform = initTransform();
        transform.mouse_enter_x = this.real_x;
        transform.mouse_enter_y = this.real_y;
        transform.mouse_origin_x = this.mouse_x;
        transform.mouse_origin_y = this.mouse_y;
        transform.mouse_transform_func = this.mouse_transforms[this.mouse_transforms.length - 1].mouse_transform_func + 1

        transform.attractors = out[0];
        transform.mouse_speed = out[1];
        transform.lanes = out[2];
        // console.log(transform.attractors)
        // console.log("Updating to", transform.mouse_transform_func)
        mouseState.mouse_transforms.push(transform)
        themeState.toggleDisplayMouseGravity()
        themeState.toggleDisplayMouseGravity()

    }


    rollTransform() {
        let rand = create(this.mouse_transforms[this.mouse_transforms.length - 1].mouse_transform_func + 1);
        let next = this.mouse_transforms[this.mouse_transforms.length - 1].mouse_transform_func + 1;
        // console.log("Returning mouse",next % 2 === 0 && next !== 0)
        let out = randomize_challenge(rand,
            next % 2 === 1, next % 2 === 0 && next !== 0)
        this.addTransform(out)
    }

}


const mouseState = new MouseState();

export {mouseState, randomize_challenge};